export enum PAGE_SLUG {
	ORDERS_REDESIGN = 'orders_redesign',
	REGISTRATION_OFFICE_REDESIGN = 'registration_office_redesign',
	NEW_ACTS = 'new_acts',
	AGREEMENTS = 'agreements',
	MERCHANT_STATUS_MAPPINGS = 'merchant_status_mappings',
	ADVERTISEMENT = 'advertisement',
	BANK_EMPLOYEES = 'bank_employees',
	DEPARTMENTS = 'departments',
	IBRO_NEO = 'ibro_neo',
	LEAD_PRO = 'lead_pro',
	BUSINESAPP_DIRECTORY = 'businessapp_directory',
	ORDER_TASK_STATS = 'order_task_stats',
	ONE_DAY_PARTNERS = 'one_day_partners',
	PARTNER_REQUEST = 'partner_request',
	PARTNER_CONTRACTS = 'partner_contracts',
	REGISTRY_BUSINESS_ACCESS_NEO = 'registry_business_access_neo',
}
